<template>
  <div class="picker">
    <a-row :gutter="12">
      <a-col :span="12">
        <span>Usuarios</span>
        <CustomScrollbar class="panel panel--left" :height="`${height}px`">
          <a-input placeholder="Buscar usuarios" @change="handleSearchUsers">
            <template #prefix>
              <SearchOutlined />
            </template>
          </a-input>
          <div class="input">
            <a-checkbox v-model:checked="selectedAll" :disabled="disabled">
              Seleccionar todos</a-checkbox
            >
          </div>
          <div v-for="item in filteredUsers" :key="item.id" class="input">
            <a-checkbox
              :checked="isActive(item)"
              @change="handleToggle($event, item)"
              :disabled="disabled"
            >
              {{ item?.fullname || item?.full_name }}
            </a-checkbox>
          </div>
        </CustomScrollbar>
      </a-col>
      <a-col :span="12">
        <span>Seleccionados</span>
        <CustomScrollbar class="panel panel--high" :height="`${height}px`">
          <div
            v-for="item in selecteds"
            :key="item?.fullname || item?.full_name"
            class="block__item"
            :class="{ disabled: disabled }"
          >
            <span>{{ item?.fullname || item?.full_name }}</span>

            <CloseOutlined class="block__icon" @click="handleRemove(item)" />
          </div>
        </CustomScrollbar>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { ref, computed, watch } from "vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons-vue";

export default {
  components: {
    CustomScrollbar,
    CloseOutlined,
    SearchOutlined,
  },
  props: {
    value: {
      required: true,
      type: Array,
    },
    items: {
      required: true,
      type: Array,
    },
    height: {
      required: false,
      type: Number,
      default: 280,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const selecteds = ref(props.value);
    const searchUser = ref("");

    const selectedAll = computed({
      get() {
        if (props.items.length == 0) return false;
        if (props.items.length == selecteds.value.length) return true;
        else return false;
      },
      set(value) {
        if (value) {
          selecteds.value = [...props.items];
        } else {
          selecteds.value = [];
        }
        emit("update:value", selecteds.value);
        emit("change");
      },
    });

    const filteredUsers = computed(() => {
      return props.items.filter((item) => {
        const itemKey = item?.fullname ? "fullname" : "full_name";

        return item?.[itemKey]?.toLowerCase().match(searchUser.value.toLowerCase());
      });
    });

    const handleSearchUsers = (event) => {
      searchUser.value = event.target.value;
    };

    const isActive = (item) => {
      return !!selecteds.value.find((selectedItem) => selectedItem.id === item.id);
    };

    const handleToggle = (event, item) => {
      if (event.target.checked) {
        selecteds.value = [...selecteds.value, item];
      } else {
        const filteredItems = selecteds.value.filter((selectedItem) => {
          return selectedItem.id !== item.id;
        });
        selecteds.value = filteredItems;
      }
      emit("update:value", selecteds.value);
      emit("change");
    };

    const handleRemove = (item) => {
      if (!props.disabled) {
        const filteredItems = selecteds.value.filter((selectedItem) => {
          return selectedItem.id !== item.id;
        });
        selecteds.value = filteredItems;
        emit("update:value", selecteds.value);
        emit("change");
      }
    };

    watch(
      () => props.value,
      (value) => {
        if (selecteds.value != value) selecteds.value = value;
      },
      { immediate: true }
    );

    return {
      selecteds,
      searchUser,
      selectedAll,
      filteredUsers,
      handleSearchUsers,
      isActive,
      handleToggle,
      handleRemove,
      props,
    };
  },
};
</script>

<style lang="sass" scoped>
.picker
  margin: 12px auto
  user-select: none

.panel
  padding: 12px
  margin: 4px 0
  border-radius: 2px
  border: $border-normal

  &--high
    padding: 4px 8px

.input
  padding: 4px 0

.block
  margin-bottom: 12px

  &__item
    font-size: 12px
    display: flex
    align-items: center
    justify-content: space-between
    background-color: $blue-1
    border: 1px solid $blue-3
    border-radius: 2px
    padding: 2px 8px
    margin: 4px 0

  &__icon
    font-size: 10px

.block__item.disabled
  color: rgba(0, 0, 0, 0.25)
  background: rgba(0, 0, 0, 0.04)
  cursor: not-allowed
  border: 1px solid rgba(0, 0, 0, 0.1)
  .anticon
    cursor: not-allowed
</style>
